import { useCallback, useContext } from "react";
import { Card } from "reactstrap";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
	useUserPreferenceActions,
	useUserProfilePreferences,
} from "../../Settings/Configuration/api/useUserPreferences";
import Content from "../../Settings/General/Notifications/Content";
import { ProfileContext } from "../context";

function NotificationSettings() {
	const { t } = useTranslation();
	const { user, isSelf } = useContext(ProfileContext);
	const { data, isLoading } = useUserProfilePreferences(user?.id);

	const { submit, submitting } = useUserPreferenceActions("notifications");

	const onFinish = useCallback(
		async (config, onSuccess) => {
			try {
				const response = await submit({
					entity: "user",
					entityId: user?.id,
					config
				});
				if (response) {
					onSuccess?.(response);
					toast.success(t("preferences-saved-successfully"));
				}
			} catch (error) {
				toast.error(t("error-saving-preferences"));
			}
		},
		[submit, user?.id, t]
	);

	return (
		<Card className="h-100">
			<Content
				values={data?.id ? { notifications: data.config } : data} // workaround
				loading={isLoading}
				submitting={submitting}
				submit={onFinish}
				page="profile"
				isSelf={isSelf}
				user={user}
			/>
		</Card>
	);
};

export default NotificationSettings;
